import { FlowsTable } from "@/components/Flows/FlowsTable";
import { Badge } from "@/components/shadcn/badge";
import { Circle } from "lucide-react";

const badgeVariants = [
  "default",
  "secondary",
  "outline",
  "destructive",
  "success",
  "ghost",
  "link",
  "color-slate",
  "color-gray",
  "color-zinc",
  "color-orange",
  "color-amber",
  "color-yellow",
  "color-lime",
  "color-emerald",
  "color-teal",
  "color-cyan",
  "color-sky",
  "color-blue",
  "color-indigo",
  "color-violet",
  "color-purple",
  "color-fuchsia",
  "color-pink",
  "color-rose",
] as const;

const FlowsWorkshop = () => {
  return (
    <div className="w-full flex flex-col flex-1 pb-5">
      <FlowsTable />
    </div>
  );
};

export default FlowsWorkshop;
